import { useMemo } from 'react'

import { campaignPublicSelector, useModal } from 'primsell-shared-layer/features'

import { Modal, Typography } from 'primsell-shared-layer/components'

import { errorModalConfig } from './error-modal.config'

import { ErrorModalStateT, PaymentErrorsE } from './error-modal.types'

import * as S from './error-modal.styles'
import { useSelector } from 'react-redux'

const ErrorModal = () => {
  const { modalConfig } = useModal<ErrorModalStateT>()
  const campaignPublicDetails = useSelector(campaignPublicSelector)

  const Icon = useMemo(() => {
    if (!modalConfig.state) {
      return
    }

    return errorModalConfig[modalConfig.state.errorType].icon
  }, [modalConfig.state])

  const title = useMemo(() => {
    if (!modalConfig.state) {
      return
    }

    let configTitle = errorModalConfig[modalConfig.state.errorType].title

    if (modalConfig.state.errorType === PaymentErrorsE.PURCHASE_LIMIT_EXCEEDED) {
      configTitle = configTitle.replace('[Collection name]', campaignPublicDetails?.meta?.collectionName ?? '')
    }

    return configTitle
  }, [campaignPublicDetails?.meta?.collectionName, modalConfig.state])

  const description = useMemo(() => {
    if (!modalConfig.state) {
      return
    }

    return errorModalConfig[modalConfig.state.errorType]?.description
  }, [modalConfig.state])

  return (
    <Modal>
      <Modal.Content>
        <S.Container>
          {Icon && <Icon />}
          <S.Title>{title}</S.Title>
          {description && (
            <Typography variant="h5" color="grey">
              {description}
            </Typography>
          )}
          {modalConfig?.state?.errorType !== PaymentErrorsE.PURCHASE_LIMIT_EXCEEDED && (
            <S.Button
              color="dark"
              onClick={() => {
                window.location.reload()
              }}
            >
              Reload
            </S.Button>
          )}
        </S.Container>
      </Modal.Content>
    </Modal>
  )
}

export { ErrorModal }
